// Display a modal with ability to show/hide/re-order columns (CPGridV2 version).
// "Set Default" is not yet implemented — the button is intentionally omitted for now.
import CPModal from "shared/components/shared/CPModal/CPModal";
import * as React from "react";
import { CPGridV2Column } from "../types";
import {
  TabStrip,
  TabStripSelectEventArguments,
  TabStripTab,
} from "@progress/kendo-react-layout";
import CPButton from "shared/components/shared/CPButton/CPButton";
import CPShowHideList from "./CPShowHideList";
import { CPText } from "shared/components/base";
import CPReorderColumnsList from "./CPReorderColumnsList";

interface CPShowHideModalProps {
  open: boolean;
  onClose: () => void;
  columns: CPGridV2Column[];
  onUpdate: (columns: CPGridV2Column[]) => void;
}

const CPShowHideModal: React.FC<CPShowHideModalProps> = (props) => {
  const [mutatedColumns, setMutatedColumns] = React.useState<CPGridV2Column[]>(
    props.columns.slice(),
  );
  const [selectedTab, setSelectedTab] = React.useState<number>(0);

  const handleTabSelect = (e: TabStripSelectEventArguments) => {
    setSelectedTab(e.selected);
  };

  const renderActionBtns = () => (
    <CPButton
      themeColor={"primary"}
      onClick={() => props.onUpdate(mutatedColumns)}
    >
      Apply
    </CPButton>
  );

  const handleShowHideClick = (column: CPGridV2Column) => {
    const itemIndex = mutatedColumns.findIndex((x) => x.title === column.title);
    const colgrp1 = mutatedColumns.slice(0, itemIndex);
    const colgrp2 = mutatedColumns.slice(itemIndex + 1);
    setMutatedColumns([...colgrp1, column, ...colgrp2]);
  };

  const handleColumnSort = (columns: CPGridV2Column[]) => {
    setMutatedColumns(columns);
  };

  return (
    <CPModal
      open={props.open}
      title="Show/Hide/Reorder Columns"
      onClose={props.onClose}
      actionBtns={renderActionBtns()}
    >
      <TabStrip
        selected={selectedTab}
        onSelect={handleTabSelect}
        animation={false}
      >
        <TabStripTab title="Show/Hide Columns">
          <CPText align="center">Check columns you want to show.</CPText>
          <CPShowHideList
            columns={mutatedColumns}
            onUpdate={handleShowHideClick}
          />
        </TabStripTab>
        <TabStripTab title="Reorder Columns">
          <CPReorderColumnsList
            columns={mutatedColumns}
            onUpdate={handleColumnSort}
          />
        </TabStripTab>
      </TabStrip>
    </CPModal>
  );
};

export default CPShowHideModal;
